import { FC, useEffect } from 'react';
import styled from './index.module.scss';
import { useLang } from '@/app/utils/useLang';
import getLocal from '@/app/utils/getLocal';
import EfImg from 'elem/ui/ef-img';

const GetGift: FC = () => {
    const { locale } = getLocal();
    const { t } = useLang('tradein.get_gift');

    return (
        <div className={styled.GetGift}>
            <div className="tradein-spaec"></div>
            <div className="ef-container gift_content">
                <div className="gift_content_text">
                    <p className="title">{t('get_gift_title')}</p>
                    <p className="desc">{t('get_gift_desc')}</p>
                </div>
                <EfImg className="gift_content_img" pc="https://websiteoss.ecoflow.com/upload/image/1723448244015/gift%20card01.png" />
            </div>
        </div>
    );
};

export default GetGift;
